import { Exclude, Transform, Type } from 'class-transformer';
import { uniq } from 'lodash';

import { centTransform, dateTransform } from '../utils/helper';
import { Actor } from './actor.model';
import { InsModDate } from './date.model';
import { DayOfTheWeek, PeriodicItem } from './periodicitem.model';
import { Tipologiaintervento } from './tipologiaintervento.model';
import { Veicolo } from './veicolo.model';

export class PeriodicService extends InsModDate {
	id?: number;
	pickup!: string;
	dropoff!: string;
	@Transform(dateTransform)
	periodstartdate?: Date; // required
	@Transform(dateTransform)
	periodenddate?: Date; // required
	servicetypeid?: number; // required
	@Transform(dateTransform)
	bookingdate?: Date;
	bookingnumber?: number;
	status?: string;
	note?: string;
	paymentmethod?: string; // required
	paymentfreq?: PaymentFrequency;
	driverid?: number; // required
	seconddriverid?: number;
	payerid?: number; // required
	@Transform(centTransform)
	refund?: number; // required
	@Transform(centTransform)
	contribution?: number; // required
	applicant?: string;
	hqid?: number; // required
	vehicleid?: number; // required
	patientid?: number; // required
	@Transform(centTransform)
	kmcovered?: number;

	@Exclude({ toPlainOnly: true })
	@Type(() => Tipologiaintervento)
	servicetype?: Tipologiaintervento;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	payer?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	driver?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	seconddriver?: Actor;

	@Exclude({ toPlainOnly: true })
	@Type(() => PeriodicItem)
	periodicitems?: PeriodicItem[] = [];

	@Exclude({ toPlainOnly: true })
	@Type(() => Veicolo)
	vehicle?: Veicolo;

	@Exclude({ toPlainOnly: true })
	@Type(() => Actor)
	patient?: Actor;

	get item() {
		if (this.periodicitems && this.periodicitems.length) return this.periodicitems[0];
		return undefined;
	}

	get days(): string[] {
		if (!this.hasPeriodicItems) return [];

		const days: string[] = [];
		const weekDays: any[] = Object.keys(DayOfTheWeek).filter((k: any) => isNaN(k)).map((k: any) => ({
			label: k, value: DayOfTheWeek[k]
		}));
		for (const item of this.periodicitems!) {
			const day = weekDays.filter(d => d.value === item.dayoftheweek)[0];
			if (day) days.push(day);
		}

		return uniq(days).sort((k: any, j: any) => k.value - j.value);
	}

	get hasPeriodicItems() {
		return this.periodicitems && this.periodicitems?.length;
	}
}

export enum PaymentFrequency {
	NOT_SPECIFIED = 0,
	ALL_SERVICES = 1,
	ALL_ONE_WAY = 2,
	ALL_RETURNS = 3,
}